<div class="table-container">

  <table mat-table matSort #deviceslisttable class="simple-table">

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelist_name" style="width: 20%;">Nome</th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
    </ng-container>

    <ng-container matColumnDef="serial">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelist_serial" style="width: 10;">Seriale</th>
      <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
    </ng-container>

    <ng-container matColumnDef="fwVersion" *ngIf="this.isAdmin() || this.isService()">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelist_fwVersion" style="width: 5;">FW</th>
      <td mat-cell *matCellDef="let element"> {{ element.systemInfo.version }} </td>
    </ng-container>

    <ng-container matColumnDef="stateIcon">
      <th mat-header-cell *matHeaderCellDef i18n="@@devicelist_state" style="width: 5%;">Stato</th>
      <td mat-cell *matCellDef="let element" style="height:100px">

        <!-- <fa-icon icon="spinner"  [spin]="true" size="xl"></fa-icon> -->

        <fa-icon *ngIf="element.icon == ''" icon="spinner"  [spin]="true"  size="xl"></fa-icon>
        <img *ngIf="element.icon != ''" class="deviceIcon" [src]="element.icon" />
      </td>
    </ng-container>

    <ng-container matColumnDef="stateDescription">
      <th mat-header-cell *matHeaderCellDef style="width: 15%;"></th>
      <td mat-cell *matCellDef="let element">{{element.stateString}}</td>
    </ng-container>

    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef i18n="@@devicelist_city" style="width: 20%;">Città</th>
      <td mat-cell *matCellDef="let element"> {{ element.systemInfo.city }} </td>
    </ng-container>


    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef i18n="@@devicelist_address" style="width: 25%;">Indirizzo</th>
      <td mat-cell *matCellDef="let element">
        {{ element.systemInfo.address }}
        <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
      </td>
    </ng-container>




    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)" [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
    </tr>

  </table>

</div>

<!-- <app-loading-screen #deviceslistloader></app-loading-screen> -->